<div class="users-container">
    <div class="page-top-banner">
        <div class="title">
            Liste des utilisateurs
        </div>

        <div class="action-zone">
            <!-- matTooltip="{{'Users.ButtonUserCreationTooltip'|translate}}" -->
            <button mat-icon-button class="accent-button" routerLink="/management/user">
                <mat-icon>add</mat-icon>
                <span class="text-button">Créer un utilisateur</span>
            </button>
        </div>
    </div>

    @if (dataSource) {
    <div class="table-container">
        <form class="filters-form" [formGroup]="filtersForm">
            <div class="mat-elevation-z8, general-table">
                <table mat-table class="default-table" [dataSource]="dataSource" matSort>
                    <!--- Note that these columns can be defined in any order.
                The actual rendered columns are set as a property on the row definition" -->

                    <ng-container matColumnDef="display">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Nom</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="display" (keyup)="applyFilters()"
                                        autocomplete="off" />
                                    <button mat-icon-button matSuffix class="accent-button mat-accent search-icon"
                                        matTooltip="Réinitialiser le filtre" (click)="resetColumnFilter('display')"
                                        type="button">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.display }}</td>
                    </ng-container>

                    <ng-container matColumnDef="account">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Identifiant</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="account" (keyup)="applyFilters()"
                                        autocomplete="off" />
                                    <button mat-icon-button matSuffix class="accent-button mat-accent search-icon"
                                        matTooltip="Réinitialiser le filtre" (click)="resetColumnFilter('account')"
                                        type="button">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.account }}</td>
                    </ng-container>
                    <!--
          <ng-container matColumnDef="billing">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'Users.ColumnHeaderBilling'|translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.billing}} </td>
          </ng-container> -->

                    <ng-container matColumnDef="displayParentOrganization">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Organisation</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="displayParentOrganization" (keyup)="applyFilters()"
                                        autocomplete="off" />
                                    <button mat-icon-button matSuffix class="accent-button mat-accent search-icon"
                                        matTooltip="Réinitialiser le filtre"
                                        (click)="resetColumnFilter('displayParentOrganization')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.displayParentOrganization }}</td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="enabled">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'Users.ColumnHeaderEnabled'|translate}} </th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox [checked]="element.enabled" [disabled]="true"></mat-checkbox>
            </td>
          </ng-container> -->

                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Date de création</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [matDatepicker]="datepicker" formControlName="createdAt"
                                        (dateChange)="applyFilters()" autocomplete="off" />
                                    <div matSuffix style="display: flex">
                                        <mat-datepicker-toggle matSuffix class="accent-button"
                                            class="mat-accent search-icon" [for]="datepicker"></mat-datepicker-toggle>
                                        <mat-datepicker #datepicker></mat-datepicker>
                                        <button mat-icon-button matSuffix class="accent-button mat-accent search-icon"
                                            matTooltip="Réinitialiser le filtre"
                                            (click)="resetColumnFilter('createdAt')">
                                            <mat-icon>clear</mat-icon>
                                        </button>
                                    </div>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.createdAt }}</td>
                    </ng-container>

                    <ng-container matColumnDef="lastConnection">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Date de dernière connexion</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput [matDatepicker]="datepicker" formControlName="lastConnection"
                                        (dateChange)="applyFilters()" autocomplete="off" />
                                    <div matSuffix style="display: flex">
                                        <mat-datepicker-toggle matSuffix class="accent-button"
                                            class="mat-accent search-icon" [for]="datepicker"></mat-datepicker-toggle>
                                        <mat-datepicker #datepicker></mat-datepicker>
                                        <button mat-icon-button class="accent-button mat-accent search-icon" matSuffix
                                            matTooltip="Réinitialiser le filtre"
                                            (click)="resetColumnFilter('lastConnection')">
                                            <mat-icon>clear</mat-icon>
                                        </button>
                                    </div>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.lastConnection }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef>
                            <button mat-icon-button class="accent-button" matSuffix matTooltip="Réinitialiser le filtre"
                                (click)="resetAllColumnFilter()">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="actions-cell">
                                <button mat-icon-button routerLink="/management/user"
                                    [queryParams]="{ id: element.id }">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                @if (!isCurrentUser(element)) {
                                <button mat-icon-button (click)="onDeleteClick(element.display, element.id)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                                }
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <mat-paginator [length]="dataSource.data.length" [pageSize]="10" [pageSizeOptions]="[5, 10, 25]">
                </mat-paginator>

            </div>
        </form>
    </div>
    }
</div>
<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#00D2B4" type="timer"
    [fullScreen]="true"></ngx-spinner>